import { useFishDetails } from '../FishDetailsContext';
import { GuestScorecards } from '@Components/Guest';
import ProfileInsights from '@Components/ProfileInsights';

export default function OverviewPanel({ variant }) {
  const { activity, aiSummary, fullContact, isLoading } = useFishDetails();

  const totals = activity?.meta?.activityTotals;
  const scorecards = totals && {
    eaten: totals.restaurantReservations,
    stayed: totals.hotelStays,
    played: totals.ticketedEvents,
    celebrated: totals.bookedEvents,
  };

  // Guests and members always get the row, so an empty one reads as "no visits
  // yet". Staff are only shown it once they have activity of their own.
  const showScorecards =
    !isLoading &&
    scorecards &&
    (variant !== 'team-member' ||
      Object.values(scorecards).some((count) => count > 0));

  return (
    <>
      {showScorecards && <GuestScorecards scorecards={scorecards} />}
      <ProfileInsights aiSummary={aiSummary} fullContact={fullContact} />
    </>
  );
}
